

export class BridgeActionResult {
	wasSuccessful: boolean;
	error?: BridgeErrorStrings;

	constructor(wasSuccessful: boolean, error?: BridgeErrorStrings) {
		this.wasSuccessful = wasSuccessful;
		this.error = error;
	}
}

export enum BridgeErrorStrings {
	already_running = "Already running",
	no_asset = "Cannot find animation, sequence, texture or file",
	no_camera = "Cannot find camera",

	activate_animation_default = "Unable to activate animation",
	deactivate_animation_default = "Unable to deactivate animation",
	register_animation_default = "Unable to register animation",
	deregister_animation_default = "Unable to deregister animation",
	register_sequence_default = "Unable to register sequence",
	deregister_sequence_default = "Unable to deregister sequence",
}

export interface IncomingFlutterMessage {
	event_type: IncomingFlutterMessageType;
	payload: any;
}

export enum IncomingFlutterMessageType {
	register_animation = "register_animation",
	register_sequence = "register_sequence",
	dispose_animation = "dispose_animation",
	set_camera = "set_camera",
	set_equipment = "set_equipment",
	character_facing = "character_facing",
	character_eyes = "character_eyes",
	character_fade = "character_fade",
	play_animation = "play_animation",
	play_sequence = "play_sequence",
	pause_tick = "pause_tick",
	soft_idle = "soft_idle",
	idle = "idle",
}

export interface OutgoingAsynchronousMessage {
	type: OutgoingAsynchronousMessageType;
	payload: OutgoingAsynchronousMessagePayload;
}

export enum OutgoingAsynchronousMessageType {
	player_ready = "player_ready",
	unknown_error = "unknown_error",
	animation_registered = "animation_registered",
	animation_disposed = "animation_disposed",
	sequence_registered = "sequence_registered",
	sequence_disposed = "sequence_disposed",
}

export interface OutgoingAsynchronousMessagePayload {
	exercise_variant_id?: string;
	result: string;
	error?: string;
}

export interface OutgoingSynchronousMessage {
	result: "ok" | "error";
	error?: string;
}

export enum ErrorStrings {
	animation_not_found = "Animation not found",
	no_message_handler = "Message sent with no message handler",
	unknown_error = "Unknown error occurred",
	flutter_message_error = "Message Received from Flutter in unrecognisable format"
}